import en from '../locales/en.json';
import fr from '../locales/fr.json';

const locales = { en, fr };

export const SUPPORTED_LANGS = ['en', 'fr'];
export const DEFAULT_LANG = 'en';

export function getLangFromPath(pathname) {
  if (pathname === '/fr' || pathname.startsWith('/fr/')) return 'fr';
  return 'en';
}

export function stripLang(pathname) {
  if (pathname === '/fr') return '/';
  if (pathname.startsWith('/fr/')) return pathname.slice(3);
  return pathname;
}

export function pathForLang(pathname, lang) {
  const base = stripLang(pathname);
  if (lang === 'fr') {
    return base === '/' ? '/fr' : '/fr' + base;
  }
  return base;
}

export function translate(lang, key) {
  const value = key.split('.').reduce((o, k) => (o ? o[k] : undefined), locales[lang]);
  if (value !== undefined) return value;
  if (lang !== DEFAULT_LANG) {
    const fallback = key
      .split('.')
      .reduce((o, k) => (o ? o[k] : undefined), locales[DEFAULT_LANG]);
    if (fallback !== undefined) return fallback;
  }
  return key;
}
